import { GridOverlay } from '@mui/x-data-grid'
import useTranslate from '../../../i18n/useTranslate'

const CustomNoRowsOverlay = () => {
    const translate = useTranslate()

    return (
        <GridOverlay>
            <div>{`${translate.get('UM.CLOSED.DATA_TABLE.NO_ROWS')}`}</div>
        </GridOverlay>
    )
}

export default CustomNoRowsOverlay
